<template>
  <div class="detail-padding">
    <div
    style=" text-align: left; background: linear-gradient( 45deg, #020202 0%, #001A49 100%); color:white; border-radius: 0.16rem;  padding:20px; margin-bottom:20px; font-size: 20px; font-family: HurmeGeometricSans2-SemiBold; border: 1px solid #606266;"
  >
  <img style="width: 20px; height: 20px;" src="@/assets/image/announcement.png" />
    We are transitioning to a new main network. 
    Please go to the homepage to claim airdrop on May 1 2025. 
    Your previous staking is found
    <a
      href="https://alpha.splatform.treasurenet.io"
      target="_blank"
      rel="noopener"
      style="text-decoration:underline; color:#2563eb; font-family:HurmeGeometricSans2-SemiBold;"
    >
      here</a>.
  </div>
    <div class="spaceBetween" style="margin-bottom: 0.24rem">
      <div class="spaceLeft">
        <div class="detail-title-1">Active Validators</div>
        <el-button
          type="text"
          style="margin-left: 0.16rem; color: #3172fd !important;font-family: HurmeGeometricSans2-SemiBold;"
          @click="toProfile"
        >STAKED RECORD<i class="el-icon-d-arrow-right"
        /></el-button>
      </div>
    </div>
    <div class="common-card is-border">
      <div class="common-card-main">
        <el-table class="common-table" :data="tableList" v-loading="loading">
          <el-table-column
            type="index"
            label=" "
            width="30px"
          ></el-table-column>
          <el-table-column prop="operator_address" label="Active Validators">
            <template slot-scope="{ row }">
              <div class="userinfo">
                <div class="img">
                  <img
                    v-if="row.description.pictures"
                    :src="row.description.pictures"
                    alt=""
                  />
                  <img v-else src="@/assets/image/stake/icon.png" alt=""/>
                </div>
                <span class="name">{{ row.description.moniker }}</span>
                <span
                  class="web"
                  v-if="row.description.website"
                  @click="handleOpen(row.description.website)"
                ></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Stake" align="right">
            <template slot="header">
              Stake
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content" style="text-align:center">
                  The first number displayed is the amount of UNIT staked with
                  this validator.<br/>
                  The percentage indicates how much these shares account for the
                  total <br/>
                  amount of stake UNIT in the network.
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="{ row }">
              <div>
                <big-number :number="row.tokens"/>
                <span class="td-word-sm">UNIT</span>
              </div>
              <div>
                <Ratio
                  style="font-size:14px"
                  :count="2"
                  :number="row.delegator_shares"
                />
                <span style="font-size:14px" class="td-word-sm">%</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Expected APR" align="right">
            <template slot="header">
              Expected APR
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content" style="text-align:center">
                  This is an estimate of the annualized return<br/> from staking, based on historical performance.<br/> Future performance may vary.
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="{ row }">
              <span class="td-word-sm">{{ row.apy }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="vote" label="Rewards" align="right">
            <template slot-scope="{ row }">
              <big-number :number="row.rewards" />
              <span class="td-word-sm">UNIT</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="operation" label=" " align="right">
            <template slot-scope="{ row }">
              <el-button class="btn" @click="handleStake(row)">Stake</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total.sync="queryParams.total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pageSize"
          @pagination="getList()"
        />
      </div>
    </div>

    <StakeDia ref="StakeDia" @success="getList"></StakeDia>
  </div>
</template>

<script>
import {validatorsList, getRewards, getUserInfo, getDelegationList} from "@/api/stake/stake.js";
import {getValidatorAPY} from "@/api/stake/base";
import StakeDia from "@/views/stake/activeValidators/StakeDia.vue";
import Ratio from "@/components/BigNumber/ratio";

export default {
  components: {StakeDia, Ratio},
  data() {
    return {
      loading: false,
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      account: "",
      tableList: []
    };
  },
  watch: {
    "$store.getters.metaMaskObj.account": {
      handler(newValue, oldValue) {
        this.account = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      let params = {
        limit: this.queryParams.pageSize,
        offset: this.queryParams.page,
        status: "BOND_STATUS_BONDED"
      };
      validatorsList(params)
        .then(res => {
          let list = res.validators || [];
          let promiseList = [];
          list.forEach((item, i) => {
            promiseList.push(this.getUserInfo(item));
            promiseList.push(this.getAPY(item));
          });
          Promise.all(promiseList).then(result => {
            this.tableList = list;
            console.log(this.tableList);
          });
          this.queryParams.total = Number(res.pagination.total) || 0;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    getAPY(row) {
      getValidatorAPY(row.description.moniker.toLowerCase()).then(res => {
        const apy = (res.result / (row.tokens / 1e18) * 100).toFixed(2) + '%';
        this.$set(row, 'apy', apy)
      })
    },
    getUserInfo(row) {
      if (row.description && row.description.identity) {
        getUserInfo(row.description.identity).then(res => {
          if (res.them && res.them.length > 0) {
            this.$set(
              row.description,
              "pictures",
              res.them[0].pictures.primary.url
            );
            // this.$set(row.description,'pictures',null)
          }
        });
      } else {
        row.description.pictures = null;
      }
    },
    handleGetRewards(row) {
      return new Promise((resvloe, reject) => {
        getRewards(row.operator_address)
          .then(res => {
            row.rewards = res.rewards.rewards[0].amount;
            resvloe(row);
          })
          .catch(err => {
            reject();
          });
      });
    },
    handleStake(row) {
      if (this.account == "") {
        this.$message.error("You need to log in to your wallet to continue.");
        return;
      }
      if (this.getToken()) {
        this.$refs.StakeDia.show(row);
      } else {
        this.$message.warning(
          "You must sign in to the wallet to view this page!"
        );
      }
    },
    toProfile() {
      this.$router.push("/Stake/profile");
    },
    handleOpen(url) {
      window.open(url, "_blank");
    }
  }
};
</script>
<style scoped lang="scss">
.userinfo {
  display: flex;
  gap: 0.1rem;
  margin-top: 0.05rem;

  .img {
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .name {
    font-size: 0.2rem;
    font-weight: 500;
    font-family: PlusJakartaDisplay-Medium;
    color: #ffffff;
    line-height: 0.28rem;
  }

  .web {
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 0.17rem;
    background: url("~@/assets/image/stake/web.png") no-repeat center #efefef;
    cursor: pointer;
  }
}

.btn {
  width: 108px;
  height: 44px;
  background: linear-gradient(
      90deg,
      rgba(34, 91, 252, 0) 0%,
      rgba(34, 91, 252, 0.38) 67%,
      #225bfc 100%
  );
  color: #ffffff;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
}
</style>
